import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons"
import { Link } from "gatsby"

export const Card = ({
  title,
  planList,
  classTitle,
  planTextList,
  logo,
  recomendado,
}) => {
  return (
    <>
      <div className={`${classTitle}-item ${classTitle}-item-${title}`}>
        <div className={`${classTitle}-card-title-img-container`}>
          <div className={`${classTitle}-cards-img-container`}>
            <img
              className={`${classTitle}-cards-${title}-logo`}
              src={logo}
              alt={`${classTitle}-cards-${title}-logo`}
            />
          </div>
          <div className={`${classTitle}-cards-title-${title} card-titles`}>
            <h5>PLAN</h5>
            <h6>{title.toUpperCase()}</h6>
          </div>
          {recomendado ? (
            <div className={`${classTitle}-cards-title-recomendado`}>
              <p>Recomendado</p>
            </div>
          ) : null}
        </div>
        <hr className={`${classTitle}-card-separator`} />
        <div className={`${classTitle}-card-list-container list-${title}`}>
          <ul>
            {planTextList.map((e, i) => (
              <li key={i}>
                {planList[i] === 1 ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    size="1x"
                    color="#FFC31F"
                    className="check-icon"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faTimes}
                    size="1x"
                    color="#FF641F"
                    className="times-icon"
                  />
                )}
                {e}
              </li>
            ))}
          </ul>
        </div>
        <Link className="soluciones-btn" to="/contacto">
          <div
            className={`${classTitle}-card-button-container-${title} ${classTitle}-card-button-container`}
          >
            <button>COTIZAR</button>
          </div>
        </Link>
      </div>
    </>
  )
}
